import { VUEX_LEARNING_HISTORY_MUTATION_NAMES } from "@tt-app/constants";

const {
  ACHIEVEMENT,
  ACTIVITY_SUMMARY,
  EXERCISE_LOGS,
  LEARNING_STATS,
  PERFORMANCE_SUMMARY,
  SELECTED_EXERCISE_LOG_TYPE_AND_SKILL,
  RECENT_EXERCISES,
  LOADING
} = VUEX_LEARNING_HISTORY_MUTATION_NAMES;

const historyMutations = {
  [ACHIEVEMENT](state: any, payload: any) {
    state.learnedBadges = payload.learnedBadges;
    state.trophies = payload.trophies;
  },
  [ACTIVITY_SUMMARY](state: any, payload: any) {
    state.exerciseCounts = payload;
  },
  [EXERCISE_LOGS](state: any, payload: any) {
    state.exerciseLogs = payload;
  },
  [LEARNING_STATS](state: any, payload: any) {
    const newStats = { ...state.learningStats, ...payload };
    state.learningStats = newStats;
  },
  [PERFORMANCE_SUMMARY](state: any, payload: any) {
    state.averageRetry = payload.averageRetry;
    state.exerciseCefrDistribution = payload.exerciseCefrDistribution;
    state.reactionTime = payload.reactionTime;
    state.wordsPerMinute = payload.wordsPerMinute;
  },
  [SELECTED_EXERCISE_LOG_TYPE_AND_SKILL](state: any, payload: any) {
    state.selectedExerciseLogTypeAndSkill = payload || { exerciseType: 0, exerciseSkill: 0 };
  },
  [RECENT_EXERCISES](state: any, payload: any) {
    state.recentExercises = payload;
  },
  [LOADING](state: any, load: boolean) {
    state.loading = load;
  }
};

export { historyMutations };
